module.exports = {
	"el": {
		"translation": {
			"moreInformation": "περισσότερες πληροφορίες",
			"close": "Κλείσιμο",
			"uploader": {
				"overlay": {
					"title": "Μεταφορά και απόθεση",
					"subtitle": "Τα αρχεία σας εδώ"
				},
				"form": {
					"dragAndDrop": "Μεταφορά και απόθεση",
					"or": "ή",
					"chooseFiles": "Επιλέξτε αρχεία",
					"from": "Από τον υπολογιστή σας"
				},
				"errors": {
					"file_size": "υπερβαίνει το μέγιστο μέγεθος αρχείου {{size}}.",
					"file_type": "Το {{type}} δεν είναι σωστός τύπος αρχείου."
				},
				"status": {
					"idle": "αδρανές",
					"processing": "επεξεργασία",
					"uploading": "μεταφόρτωση",
					"success": "επιτυχία",
					"cancel": "ακύρωση",
					"error": "σφάλμα",
					"none": ""
				}
			},
			"actions": {
				"delete": "Διαγραφή",
				"apply": "Εφαρμογή",
				"cancel": "Ακύρωση"
			},
			"dateInput": {
				"choose": "Επιλέξτε ημερομηνία",
				"clear": "Απαλοιφή ημερομηνίας"
			},
			"daterange": {
				"last_7_days": "Τελευταίες 7 ημέρες",
				"last_30_days": "Τελευταίες 30 ημέρες",
				"this_month": "Αυτόν τον μήνα",
				"last_month": "Τον περασμένο μήνα",
				"start_date": "Ημερομηνία έναρξης",
				"end_date": "Ημερομηνία λήξης",
				"not_set": "Δεν έχει οριστεί"
			},
			"comment": {
				"delete": "Διαγραφή σχολίου"
			},
			"pagination": {
				"intro": "Σελιδοποίηση, τώρα στη σελίδα {{currentPage}}",
				"page": "Σελίδα {{pageNumber}}",
				"ellipsis": "Περισσότερες σελίδες",
				"prev": "Προηγούμενη σελίδα",
				"next": "Επόμενη σελίδα"
			},
			"formElement": {
				"optional": "(προαιρετικό)",
				"required": "(απαιτείται)"
			},
			"prevNextArrowButton": {
				"arrowup": "πάνω",
				"arrowdown": "κάτω",
				"escape": "escape"
			},
			"externalLink": {
				"view": "προβολή"
			},
			"collapsible": {
				"ariaText": "πτυσσόμενο τμήμα"
			}
		}
	}
};